import { Redirect, Stack } from 'expo-router';
import useIsFeatureEnabled from 'shared/hooks/statsig/useIsFeatureEnabled/useIsFeatureEnabled';
import { FeatureFlagKey } from 'shared/providers/statsig/StatsigProvider.d';

function PayLaterLayout() {
  const isPayLaterEnabled = useIsFeatureEnabled(
    FeatureFlagKey.ENABLE_PAY_LATER,
  );

  if (!isPayLaterEnabled) {
    return <Redirect href="/" />;
  }

  return <Stack />;
}

export default PayLaterLayout;
